import StyledSelect from './components/styled-select';
import Accordion from './components/Accordion';

// -----------------------------------------------------------------------------
// Hero select styles
// -----------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    let element = document.querySelector('[data-styled-select]');
    new StyledSelect(element);
});

// -----------------------------------------------------------------------------
// Redirect on pricing selection
// -----------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    let element = document.querySelector('[data-styled-select-select]');

    element.addEventListener('change', () => {
        let category = element.value;
        window.location.pathname = '/pricing/' + category;
    });
});

// -----------------------------------------------------------------------------
// Accordions
// -----------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    Accordion.create();
});



// WEBPACK FOOTER //
// ./js/marketing/pricing.js